<template>
  <div class="k-table-controls-container">
    <div class="k-table-controls">
      <div class="k-table-controls-left">
        <button
          v-if="hideable && hasHideableColumns"
          class="btn btn-primary"
          @click="onToggleColumnSelector"
          :aria-expanded="isColumnSelectorOpen"
        >
          Columns
          <i class="fas fa-columns-3" aria-hidden="true"></i>
        </button>

        <div
          v-if="isColumnSelectorOpen && hasHideableColumns"
          class="k-table-column-selector"
          :class="{ 'expand-horizontally': colSelectorOptions.length > 0 && hideableKeys.length > 10 }"
          role="dialog"
          aria-label="Column visibility options"
        >
        <div class="k-table-column-selector-container">
          <ul v-if="colSelectorOptions.length > 0" class="k-table-special-selectors">
            <div class="k-table-column-selector-header">
              <h3>Column Group Filters</h3>
            </div>
            <li v-for="(colSelector, index) in colSelectorOptions" :key="colSelector.text">
              <label class="k-custom-checkbox">
                <input
                  type="checkbox"
                  :checked="activeColSelectors.includes(index)"
                  @change="onFilterToggle(index)"
                  class="hidden-checkbox"
                />
                <span class="k-custom-checkbox-box ph-no-capture"></span>
                <span class="k-custom-checkbox-text">{{ colSelector.text }}</span>
              </label>
            </li>
          </ul>
        </div>
        <div class="k-table-column-visible-columns">
          <div v-if="colSelectorOptions.length > 0" class="dropdown-divider"><hr v-if="hideableKeys.length < 10"></div>
            <div class="k-table-column-selector-header">
              <h3>Visible Columns</h3>
              <button
                class="btn btn-link"
                @click="onResetColumns"
              >
                Reset
              </button>
            </div>
              <div class="k-table-column-selector-content">
                <div
                  v-for="key in hideableKeys"
                  :key="key"
                  class="k-table-column-selector-item"
                >
                  <label class="k-custom-checkbox">
                    <input
                      type="checkbox"
                      class="hidden-checkbox"
                      :checked="shownKeys.includes(key)"
                      @change="onColumnToggle(key, $event)"
                      :aria-label="`Toggle ${headers[key].name} column`"
                    >
                    <span class="k-custom-checkbox-box"></span>
                    <span class="k-custom-checkbox-text">{{ headers[key].name }}</span>
                  </label>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="k-table-controls-right">
        <div class="k-table-controls-group">
          <button
            v-if="downloadable"
            class="btn btn-outlined"
            @click="onDownload"
          >
            Download (.csv)
            <i class="fas fa-download" aria-hidden="true"></i>
          </button>
          <button
            v-if="filtersClearable"
            class="btn btn-outlined"
            @click="onClearFilters"
            title="Clear Filters"
          >
            Clear Filters
            <i class="fas fa-circle-xmark" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="k-table-legend" v-if="showLegend">
        <span><i class="fas fa-square optional" aria-hidden="true"></i> Optional</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableControls',

  props: {
    headers: {
      type: Object,
      required: true,
    },
    shownKeys: {
      type: Array,
      required: true,
    },
    activeColSelectors: {
      type: Array,
      default: () => [],
    },
    downloadable: {
      type: Boolean,
      default: false,
    },
    colSelectorOptions: {
      type: Array,
      default: () => [],
    },
    showLegend: {
      type: Boolean,
      default: false,
    },
    hideable: {
      type: Boolean,
      default: true,
    },
    filtersClearable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isColumnSelectorOpen: false,
    };
  },

  computed: {
    hideableKeys() {
      return Object.keys(this.headers).filter(key => this.headers[key].hideable);
    },

    hasHideableColumns() {
      return this.hideableKeys.length > 0;
    },
  },

  methods: {
    onToggleColumnSelector() {
      this.isColumnSelectorOpen = !this.isColumnSelectorOpen;
    },

    onColumnToggle(key, event) {
      const checked = event.target.checked;
      const newShownKeys = checked
        ? [...this.shownKeys, key]
        : this.shownKeys.filter(k => k !== key);

      this.$emit('update:shownKeys', newShownKeys);
    },

    onFilterToggle(index) {
      const isActive = this.activeColSelectors.includes(index);
      const newFilters = isActive ? this.activeColSelectors.filter(i => i !== index) : [...this.activeColSelectors, index];
      this.$emit('update:activeColSelectors', newFilters);
    },

    onResetColumns() {
      this.$emit('reset-columns');
    },

    onDownload() {
      this.$emit('download');
    },

    onClearFilters() {
      this.$emit('clear-filters');
    },
  },
};
</script>
